import { MembershipService } from './MembershipService'

import { appConfig } from 'Config'

export const memberShipService = new MembershipService({ baseURL: appConfig.memberShipService.baseUrl })
